(() => {
  const handleize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const PRODUCT_LINE_TAGS = new Set([
    'seatarmour',
    'seat-towels',
    'center-console',
    'pet-beds',
    'seat-belt',
    'custom-corporate',
  ]);

  const BRAND_TAGS = new Set([
    'chevrolet',
    'chevy',
    'ford',
    'gmc',
    'toyota',
    'jeep',
    'honda',
    'ram',
    'nissan',
    'acura',
    'dodge',
    'bmw',
    'hyundai',
    'kia',
    'subaru',
    'mazda',
    'cadillac',
    'buick',
    'chrysler',
    'lexus',
    'lincoln',
    'volkswagen',
    'porsche',
    'tesla',
    'camaro',
    'corvette',
    'mustang',
    'charger',
    'infiniti',
    'mercedes-benz',
    'f-150',
    'wrangler',
    'bmw-stripe',
    'bmw-stripes',
    'mercedes',
  ]);

  const normalizeCatalogTagUrl = () => {
    const { pathname, search, origin } = window.location;
    const params = new URLSearchParams(search);

    const pathMatch = pathname.match(/^\/collections\/all\/([^/?#]+)/i);
    if (pathMatch) {
      const tags = pathMatch[1]
        .split('+')
        .map((tag) => decodeURIComponent(tag).trim())
        .filter(Boolean);

      if (tags.length === 1) {
        const tag = handleize(tags[0]);
        if (BRAND_TAGS.has(tag) && !params.has('sa_brand')) {
          const url = new URL(origin);
          url.pathname = '/collections/all';
          params.set('sa_brand', tag);
          url.search = params.toString();
          window.location.replace(`${url.pathname}${url.search ? `?${url.search}` : ''}`);
          return;
        }
      }

      if (tags.length > 1) {
        const line = tags.find((tag) => PRODUCT_LINE_TAGS.has(handleize(tag)));
        const brand = tags.find((tag) => !PRODUCT_LINE_TAGS.has(handleize(tag)) && handleize(tag) !== handleize(line));

        if (line && brand) {
          const url = new URL(origin);
          url.pathname = `/collections/all/${handleize(line)}`;
          params.delete('sa_brand');
          params.set('sa_brand', handleize(brand));
          url.search = params.toString();
          window.location.replace(`${url.pathname}${url.search ? `?${url.search}` : ''}`);
          return;
        }
      }
    }

    if (!/^\/collections\/all\/?$/.test(pathname)) return;

    const filterTags = params.getAll('filter.p.tag');
    if (!filterTags.length) return;

    while (params.has('filter.p.tag')) {
      params.delete('filter.p.tag');
    }

    const line = filterTags.find((tag) => PRODUCT_LINE_TAGS.has(handleize(tag)));
    const brand = filterTags.find((tag) => !PRODUCT_LINE_TAGS.has(handleize(tag)));

    const url = new URL(origin);
    if (line) {
      url.pathname = `/collections/all/${handleize(line)}`;
      if (brand) {
        params.set('sa_brand', handleize(brand));
      }
    } else if (filterTags.length) {
      url.pathname = `/collections/all/${filterTags.map((tag) => handleize(tag)).join('+')}`;
    } else {
      return;
    }

    url.search = params.toString();
    window.location.replace(`${url.pathname}${url.search ? `?${url.search}` : ''}`);
  };

  normalizeCatalogTagUrl();
})();
